<script lang="ts">
	import juslinOGImg from '$lib/assets/juslin.webp';
	import MetaHead from '$lib/components/MetaHead.svelte';
	import FaqSection from '$lib/components/sections/faq-section.svelte';
	let { data } = $props();
	const stack = [
		{
			categorie: 'Frontend',
			technos: ['SvelteKit', 'React', 'Next.js', 'TypeScript', 'Tailwind CSS']
		},
		{ categorie: 'Backend', technos: ['Node.js', 'Express', 'Hono', 'REST API', 'GraphQL'] },
		{
			categorie: 'Base de données',
			technos: ['PostgreSQL', 'Drizzle ORM', 'Elasticsearch', 'Redis']
		},
		{ categorie: 'DevOps & Cloud', technos: ['Vercel', 'Docker', 'GitHub Actions', 'Linux'] },
		{ categorie: 'IA & Automatisation', technos: ['OpenAI API', 'Claude API', 'n8n', 'Zapier'] }
	];

	const valeurs = [
		{
			titre: 'Impact avant tout',
			description:
				"La technologie n'est qu'un moyen. Ce qui compte, c'est l'impact mesurable qu'elle génère sur votre business — revenus, efficacité, autonomie."
		},
		{
			titre: 'Transparence totale',
			description:
				'Je dis ce qui est faisable, dans quel délai et à quel coût réel. Pas de promesses impossibles, pas de devis qui gonflent en cours de route.'
		},
		{
			titre: 'Livraison continue',
			description:
				"Pas de big bang après 6 mois. Vous voyez des résultats toutes les 2 semaines, vous donnez votre feedback, on ajuste. C'est ça, l'agilité réelle."
		},
		{
			titre: 'Autonomie du client',
			description:
				"Mon objectif n'est pas de créer une dépendance. Chaque mission inclut une transmission : vous comprenez ce qui a été construit et pourquoi."
		}
	];

	const nonFaire = [
		'Je ne fais pas de sites vitrines low-cost sans stratégie',
		'Je ne prends pas de projets sans vision claire ni objectif mesurable',
		'Je ne travaille pas avec des clients qui veulent une agence, pas un partenaire',
		"Je ne livre pas un produit sans vous avoir formé à l'utiliser",
		'Je ne promets pas des résultats en dehors de votre portée ou budget'
	];

	const certifications = [
		{
			titre: 'Développement Web Full-Stack',
			organisme: 'Formation autodidacte & projets terrain',
			annee: '2014 — présent'
		},
		{
			titre: 'Product Engineering',
			organisme: 'Expérience en startup & scale-up',
			annee: '10+ ans'
		},
		{
			titre: 'Intelligence Artificielle appliquée',
			organisme: 'OpenAI, Anthropic, Google Gemini',
			annee: '2023 — présent'
		},
		{
			titre: 'Mentorat & pédagogie digitale',
			organisme: 'Academy Juslin',
			annee: '200+ apprenants'
		}
	];

	const parcours = [
		{
			periode: '2014',
			titre: 'Les premières lignes de code',
			description:
				"Tout commence par une frustration simple : avoir des idées et ne pas pouvoir les construire. J'apprends à coder seul, nuit après nuit, projet après projet."
		},
		{
			periode: '2016–2020',
			titre: 'Startups & terrain',
			description:
				'Je travaille sur des projets réels — fintech, marketplaces, SaaS B2B. Je comprends que la technique ne suffit pas : il faut comprendre le business.'
		},
		{
			periode: '2020–2022',
			titre: 'Product Engineer confirmé',
			description:
				"Je pilote des projets de A à Z pour des clients en Côte d'Ivoire, en France et à l'international. La Méthode I.M.P.A.C.T prend forme."
		},
		{
			periode: "2022 — aujourd'hui",
			titre: 'Construire & transmettre',
			description:
				"Je fonde l'Academy pour former la prochaine génération. 200+ apprenants mentorés. Je continue à livrer des produits à fort impact en parallèle."
		}
	];
</script>

<MetaHead {data} />
<!-- HERO -->
<section
	class="relative overflow-hidden border-b border-[--border] bg-[--card] px-6 py-20 sm:py-28"
>
	<div class="mx-auto max-w-4xl">
		<div class="flex flex-col items-start gap-10 sm:flex-row sm:items-center">
			<div class="shrink-0">
				<div
					class="relative h-24 w-24 overflow-hidden rounded-2xl border-2 border-[--juslin-gold]/40 shadow-xl sm:h-32 sm:w-32"
				>
					<img src={juslinOGImg} alt="Juslin Komenan" class="h-full w-full object-cover" />
				</div>
			</div>
			<div>
				<span
					class="mb-3 inline-block rounded-full border border-[--juslin-gold]/30 bg-[--juslin-gold]/10 px-3 py-1 text-xs font-semibold tracking-widest text-[--juslin-gold] uppercase"
				>
					À propos
				</span>
				<h1 class="text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl">Juslin Komenan</h1>
				<p class="mt-2 text-lg text-[--muted-foreground]">Product Engineer & Digital Architect</p>
				<p class="mt-4 max-w-xl text-base leading-relaxed text-[--muted-foreground]">
					Je construis des solutions digitales à fort impact pour startups et PME, et forme la
					prochaine génération de créateurs via l'Academy. Basé en Côte d'Ivoire, j'interviens à
					l'international.
				</p>
				<div class="mt-6 flex flex-wrap gap-6 text-sm">
					<div>
						<span class="block text-2xl font-bold text-[--juslin-gold]">10+</span>
						<span class="text-[--muted-foreground]">années d'XP</span>
					</div>
					<div>
						<span class="block text-2xl font-bold text-[--juslin-gold]">5+</span>
						<span class="text-[--muted-foreground]">projets livrés</span>
					</div>
					<div>
						<span class="block text-2xl font-bold text-[--juslin-gold]">200+</span>
						<span class="text-[--muted-foreground]">apprenants mentorés</span>
					</div>
					<div>
						<span class="block text-2xl font-bold text-[--juslin-gold]">3</span>
						<span class="text-[--muted-foreground]">pays clients</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- MON HISTOIRE -->
<section class="px-6 py-20">
	<div class="mx-auto max-w-4xl">
		<span
			class="mb-3 inline-block text-xs font-semibold tracking-widest text-[--juslin-gold] uppercase"
		>
			Mon parcours
		</span>
		<h2 class="mb-4 text-2xl font-bold sm:text-3xl">Comment j'en suis arrivé là</h2>
		<p class="mb-12 max-w-2xl text-[--muted-foreground]">
			Tout a commencé par une frustration partagée par beaucoup d'entrepreneurs : voir des idées
			brillantes échouer, non pas par manque de créativité, mais faute d'exécution technique
			adaptée.
		</p>

		<div class="relative">
			<!-- Ligne verticale -->
			<div
				class="absolute top-0 bottom-0 left-4 w-px bg-[--border] sm:left-[88px]"
				aria-hidden="true"
			></div>

			<div class="flex flex-col gap-10">
				{#each parcours as etape}
					<div class="relative flex gap-6 sm:gap-10">
						<div class="flex shrink-0 flex-col items-center sm:w-24 sm:items-end">
							<div
								class="relative z-10 mt-1 h-3 w-3 rounded-full border-2 border-[--juslin-gold] bg-[--background] sm:mt-1.5"
							></div>
						</div>
						<div class="pb-2">
							<span class="mb-1 block text-xs font-semibold text-[--juslin-gold]">
								{etape.periode}
							</span>
							<h3 class="mb-1 font-semibold">{etape.titre}</h3>
							<p class="text-sm leading-relaxed text-[--muted-foreground]">
								{etape.description}
							</p>
						</div>
					</div>
				{/each}
			</div>
		</div>
	</div>
</section>

<!-- MES VALEURS -->
<section class="border-y border-[--border] bg-[--card] px-6 py-20">
	<div class="mx-auto max-w-4xl">
		<span
			class="mb-3 inline-block text-xs font-semibold tracking-widest text-[--juslin-gold] uppercase"
		>
			Ce qui me guide
		</span>
		<h2 class="mb-12 text-2xl font-bold sm:text-3xl">Mes valeurs de travail</h2>

		<div class="grid gap-6 sm:grid-cols-2">
			{#each valeurs as valeur, i}
				<div class="rounded-xl border border-[--border] bg-[--background] p-6">
					<div
						class="mb-3 flex h-8 w-8 items-center justify-center rounded-lg bg-[--juslin-gold]/10 text-sm font-bold text-[--juslin-gold]"
					>
						{i + 1}
					</div>
					<h3 class="mb-2 font-semibold">{valeur.titre}</h3>
					<p class="text-sm leading-relaxed text-[--muted-foreground]">{valeur.description}</p>
				</div>
			{/each}
		</div>
	</div>
</section>

<!-- MA STACK TECHNIQUE -->
<section class="px-6 py-20">
	<div class="mx-auto max-w-4xl">
		<span
			class="mb-3 inline-block text-xs font-semibold tracking-widest text-[--juslin-gold] uppercase"
		>
			Outils & technologies
		</span>
		<h2 class="mb-4 text-2xl font-bold sm:text-3xl">Ma stack technique</h2>
		<p class="mb-12 max-w-xl text-[--muted-foreground]">
			Je choisis mes outils en fonction du projet, pas de la mode. Voici les technologies que
			j'utilise au quotidien et en lesquelles j'ai une confiance éprouvée.
		</p>

		<div class="flex flex-col gap-6">
			{#each stack as categorie}
				<div class="flex flex-col gap-3 sm:flex-row sm:items-start sm:gap-8">
					<span
						class="w-full shrink-0 text-xs font-semibold tracking-widest text-[--muted-foreground] uppercase sm:w-36 sm:pt-1.5 sm:text-right"
					>
						{categorie.categorie}
					</span>
					<div class="flex flex-wrap gap-2">
						{#each categorie.technos as techno}
							<span
								class="rounded-full border border-[--border] bg-[--card] px-3 py-1 text-sm font-medium"
							>
								{techno}
							</span>
						{/each}
					</div>
				</div>
			{/each}
		</div>
	</div>
</section>

<!-- CERTIFICATIONS & FORMATIONS -->
<section class="border-y border-[--border] bg-[--card] px-6 py-20">
	<div class="mx-auto max-w-4xl">
		<span
			class="mb-3 inline-block text-xs font-semibold tracking-widest text-[--juslin-gold] uppercase"
		>
			Expériences & formations
		</span>
		<h2 class="mb-12 text-2xl font-bold sm:text-3xl">Ce qui forge mon expertise</h2>

		<div class="grid gap-4 sm:grid-cols-2">
			{#each certifications as cert}
				<div class="flex gap-4 rounded-xl border border-[--border] bg-[--background] p-5">
					<div
						class="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[--juslin-gold]/10"
					>
						<svg
							class="h-4 w-4 text-[--juslin-gold]"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
							stroke-width="2"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
							/>
						</svg>
					</div>
					<div>
						<h3 class="font-semibold">{cert.titre}</h3>
						<p class="text-sm text-[--muted-foreground]">{cert.organisme}</p>
						<span class="mt-1 block text-xs text-[--juslin-gold]">{cert.annee}</span>
					</div>
				</div>
			{/each}
		</div>
	</div>
</section>

<!-- CE QUE JE NE FAIS PAS -->
<section class="px-6 py-20">
	<div class="mx-auto max-w-4xl">
		<span
			class="mb-3 inline-block text-xs font-semibold tracking-widest text-[--juslin-gold] uppercase"
		>
			Limites claires
		</span>
		<h2 class="mb-4 text-2xl font-bold sm:text-3xl">Ce que je ne fais pas</h2>
		<p class="mb-10 max-w-xl text-[--muted-foreground]">
			La clarté sur ce que je ne fais pas est aussi importante que ce que je fais. Ça nous évite de
			perdre du temps à tous les deux.
		</p>

		<div class="flex flex-col gap-3">
			{#each nonFaire as item}
				<div
					class="flex items-start gap-3 rounded-xl border border-[--border] bg-[--card] px-5 py-4"
				>
					<svg
						class="mt-0.5 h-4 w-4 shrink-0 text-red-400"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
						stroke-width="2.5"
					>
						<path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
					</svg>
					<span class="text-sm">{item}</span>
				</div>
			{/each}
		</div>
	</div>
</section>
<FaqSection items={data.faqItems} title="Questions fréquentes" />
<!-- CTA RESSOURCES -->
<section class="border-t border-[--border] bg-[--card] px-6 py-20">
	<div class="mx-auto max-w-2xl text-center">
		<span
			class="mb-3 inline-block text-xs font-semibold tracking-widest text-[--juslin-gold] uppercase"
		>
			Prochaine étape
		</span>
		<h2 class="mb-4 text-2xl font-bold sm:text-3xl">Apprenez à votre rythme</h2>
		<p class="mb-8 text-[--muted-foreground]">
			Articles, études de cas et guides pratiques pour vous aider à prendre les bonnes décisions
			tech, éviter les erreurs coûteuses et faire avancer votre projet.
		</p>
		<a
			href="/resources"
			class="inline-flex items-center gap-2 rounded-full bg-[--juslin-gold] px-8 py-3 text-sm font-bold text-black shadow-md transition-all duration-200 hover:scale-105 hover:bg-[--juslin-gold]/90"
		>
			Voir les ressources →
		</a>
	</div>
</section>
